import { z } from "zod";

export const DischargeLetterAccidentSurgeryFormSchema = z.object({
  additional_diagnostic_findings: z.string().optional(),
  allergies: z.string().optional(),
  anamnesis: z.string().optional(),
  appointments: z.string().optional(),
  clinical_course: z.string().optional(),
  diagnoses: z.string().optional(),
  discharge_medications: z.string().optional(),
  ecg: z.string().optional(),
  lab_results: z.string().optional(),
  parameters: z.string().optional(),
  physical_status: z.string().optional(),
  recommendations: z.string().optional(),
  social_anamnesis: z.string().optional(),
  therapy: z.string().optional(),
});
